import { I18nProvider } from '@/ui/i18n/I18nProvider';
import { AppShell } from '@/ui/layouts/AppShell';

export function App() {
  return (
    <I18nProvider>
      <AppShell />
    </I18nProvider>
  );
}
